import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RefreshCwIcon } from 'lucide-react';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { CryptoCardSkeleton } from '../components/SkeletonLoader';
import { useCryptoData } from '../hooks/useCryptoData';
export function CryptocurrenciesPage() {
  const {
    data: cryptocurrencies,
    loading,
    error,
    lastUpdated,
    refresh
  } = useCryptoData(100);
  const [refreshing, setRefreshing] = useState(false);
  const handleRefresh = async () => {
    setRefreshing(true);
    await refresh();
    setRefreshing(false);
  };
  return <div className="min-h-screen bg-slate-50" data-id="element-309">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-310">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
          <div className="flex items-center justify-between mb-3" data-id="element-312">
            <h1 className="text-4xl font-bold" data-id="element-313">Top Cryptocurrencies</h1>
            <button onClick={handleRefresh} disabled={refreshing} className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors disabled:opacity-50" data-id="element-314">
              <RefreshCwIcon size={18} className={refreshing ? 'animate-spin' : ''} data-id="element-315" />
              <span className="text-sm font-medium" data-id="element-316">Refresh</span>
            </button>
          </div>
          <p className="text-slate-300 text-lg" data-id="element-317">
            Live cryptocurrency prices and market data
          </p>
          {!loading && <p className="text-slate-400 text-sm mt-2" data-id="element-318">
              Last updated: {lastUpdated.toLocaleTimeString()} • Auto-refreshes
              every 60s
            </p>}
        </div>
      </div>

      {error && <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-319">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-320">
            <p className="text-yellow-800 text-sm" data-id="element-321">
              <strong data-id="element-322">Note:</strong> {error}. Showing cached data.
            </p>
          </div>
        </div>}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-323">
        <div className="grid grid-cols-1 gap-4" data-id="element-324">
          {loading && cryptocurrencies.length === 0 ?
        // Initial loading state
        Array.from({
          length: 10
        }).map((_, i) => <CryptoCardSkeleton key={i} data-id="element-325" />) : cryptocurrencies.map(crypto => <Link key={crypto.id} to={`/cryptocurrency/${crypto.id}`} data-id="element-326">
                  <Card className="p-5" hover data-id="element-327">
                    <div className="flex items-center justify-between" data-id="element-328">
                      <div className="flex items-center gap-4" data-id="element-329">
                        <div className="flex items-center gap-3" data-id="element-330">
                          <span className="text-slate-500 font-semibold text-sm w-6" data-id="element-331">
                            {crypto.rank}
                          </span>
                          <img src={crypto.logo} alt={crypto.name} className="w-10 h-10" onError={e => {
                    e.currentTarget.src = 'https://via.placeholder.com/40';
                  }} data-id="element-332" />
                        </div>
                        <div data-id="element-333">
                          <div className="flex items-center gap-2 mb-1" data-id="element-334">
                            <h3 className="font-semibold text-lg" data-id="element-335">
                              {crypto.name}
                            </h3>
                            <span className="text-slate-500 text-sm" data-id="element-336">
                              {crypto.symbol}
                            </span>
                          </div>
                          <TrustScore score={crypto.trustScore} size="sm" data-id="element-337" />
                        </div>
                      </div>

                      <div className="text-right" data-id="element-338">
                        <div className="font-semibold text-lg mb-1" data-id="element-339">
                          $
                          {crypto.price >= 1 ? crypto.price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : crypto.price.toFixed(6)}
                        </div>
                        <div className={`text-sm font-medium ${crypto.change24h >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-340">
                          {crypto.change24h >= 0 ? '+' : ''}
                          {crypto.change24h.toFixed(2)}%
                        </div>
                      </div>
                    </div>
                  </Card>
                </Link>)}
        </div>
      </div>
    </div>;
}